import { Box, BoxProps, Flex, Text } from '@chakra-ui/react';
import { Row } from '@tanstack/react-table';
import { useHover } from '~/screens/WhalarModeScreen/hooks/useHover';
import { ICreator } from '~/types';

import { EmptyCell } from './Columns';
import { cellContainer } from './styles';

interface Props extends BoxProps {
  row: Row<ICreator>;
}

export const AgeCell: React.FC<Props> = ({ row }) => {
  const [hoverElemRef] = useHover<HTMLDivElement>();
  const { age } = row.original;

  return (
    <Box ref={hoverElemRef} {...cellContainer}>
      {age ? (
        <Flex
          flexDirection="row"
          justifyContent="center"
          alignItems="center"
          gap={1}
        >
          <Text
            color="primary.400"
            fontSize="md"
            fontWeight="400"
            lineHeight={4}
            noOfLines={2}
          >
            {age}
          </Text>
        </Flex>
      ) : (
        <EmptyCell content="-" />
      )}
    </Box>
  );
};
